






import Vue from "vue";
import { kebabCase } from "lodash";

export default Vue.extend({
  name: "CommonTitle",
  computed: {
    href(): string {
      const id = this.$attrs && (this as any).$attrs.id! ? this.$attrs.id : "";
      return `#${kebabCase(id)}`;
    },
  },

  methods: {},
});
